<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">

        <!-- Header -->
        <Header></Header>
        <!-- /Header -->

        <!-- Sidebar -->
        <Sidebar></Sidebar>
        <!-- /Sidebar -->

        <!-- Page Wrapper -->
        <div class="page-wrapper">

            <!-- Page Content -->
            <div class="content container-fluid">

                <!-- Page Header -->
                <div class="page-header">
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="page-title">ADD SAMPLE REQUISITION</h3>
                            <hr>
                        </div>
                    </div>
                </div>
                <!-- /Page Header -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="card" style="border:5px solid #dee2e6 !important;">
                            <div class="card-header" style="background:darkgray;">
                                <h4 class="card-title mb-0" style="color:black; font-weight:bold;">Sample Requisition Form</h4>
                            </div>
                            <div class="card-body">
                                <form enctype="multipart/form-data" @submit="formSubmit">
                                    <div class="row">
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b style="font-size:large;">REQUISITION DATE:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.sample_req_date">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>APPROVAL PERSON:</b></label>
                                                <div class="col-lg-9">
                                                    <select class="form-control" v-model="form.r_apr_prs_name" required>
                                                        <option>-Select-</option>
                                                        <option>Abu Barak Siddique Khan</option>
                                                        <option>Ananto Jalil</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Buyer Name:</b></label>
                                                <div class="col-lg-9">
                                                    <select class="form-control" v-model="form.buyer">
                                                        <option>-Select-</option>
                                                        <option>X</option>
                                                        <option>Y</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Style:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.style" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Item Description:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.item_desc" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Fabric:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.fabric" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Required Fabric Qty:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.req_fab_qty" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Fabric Handover Date:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.fab_hand_date" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Original Sample:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.org_sample" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Tech Pack:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.tech_park" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Type of Sample:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.type_of_sample" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Sewing Thread (Color):</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.sewing_thread" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Required Thread Qty:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.req_thread_qty" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Required Thread Count:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.req_thread_count" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Thread Handover Date:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.thread_handover_date" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Main Label:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.main_label" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Size Label:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.size_label" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Care Label:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.care_label" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Interlining:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.interlining" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Zipper:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.zipper" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Button:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.button" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Twill Tape:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.twill_tape" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Elastic:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.elastic" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Hangtag:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.hangtag" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Stickers:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.stickers" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Fabric Shrinkage:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.fab_shrinkage" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Wash Type:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.wash_type" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Sewing Type:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.sewing_type" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Pocketing:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.pocketing" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6">
                                            <div class="form-group row">
                                                <label class="col-lg-3 col-form-label"><b>Sample Submission Date:</b></label>
                                                <div class="col-lg-9">
                                                    <input type="text" class="form-control" v-model="form.sample_sub_date" required>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-8">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th style="background:#8080801f;font-weight:bold;">COLOR</th>
                                                    <th style="background:#8080801f;font-weight:bold;">SIZE</th>
                                                    <th style="background:#8080801f;font-weight:bold;">TYPE</th>
                                                    <th style="background:#8080801f;font-weight:bold;">QTY</th>
                                                    <th style="background:#8080801f;font-weight:bold;">
                                                        <button type="button" @click="add_more_one()" class="btn btn-success btn-sm" style="border-radius:0px; background: rgb(12, 65, 40);"><i class="la la-plus-square"></i> Add More</button>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(lineOne,k) in form.lineOnes">
                                                    <td><input type="text" v-model="lineOne.color" class="form-control" required>
                                                    </td>
                                                    <td><input type="text" v-model="lineOne.size" class="form-control" required>
                                                    </td>
                                                    <td><input type="text" v-model="lineOne.type" class="form-control" required>
                                                    </td>
                                                    <td><input type="number" v-model="lineOne.qty" class="form-control" required>
                                                    </td>
                                                    <td>
                                                        <button class="btn btn-danger btn-sm" @click="removeLineOne(k)" v-if="form.lineOnes.length != 1" required style="border-radius:0px; background: #d51313;">
                                                            <i class="la la-close"></i> Remove
                                                        </button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-xl-4">
                                            <table class="table table-bordered">
                                                <thead>
                                                <tr>
                                                    <th style="background:#8080801f;font-weight:bold;">Submitted To</th>
                                                    <th style="background:#8080801f;font-weight:bold;">PCS</th>
                                                    <th style="background:#8080801f;font-weight:bold;">
                                                        <button type="button" @click="add_more_two()" class="btn btn-success btn-sm" style="border-radius:0px; background: rgb(12, 65, 40);"><i class="la la-plus-square"></i> Add More</button>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(lineTwo,k) in form.lineTwos">
                                                    <td><input type="text" v-model="lineTwo.submitted_to" class="form-control" required></td>
                                                    <td><input type="text" v-model="lineTwo.pcs" class="form-control" required></td>
                                                    <td>
                                                        <button class="btn btn-danger btn-sm" @click="removeLineTwo(k)" v-if="form.lineTwos.length != 1" required style="border-radius:0px; background: #d51313;"><i class="la la-close"></i> Remove</button>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="text-right">
                                        <button type="submit" class="btn btn-primary" style="border-radius:0px;"><i class="la la-check"></i> Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Page Content -->
        </div>
        <!-- /Page Wrapper -->

    </div>
    <!-- /Main Wrapper -->

    <!--    <div>Welcome {{ name }}</div>-->
</template>

<script>
import Sidebar from '../components/sidebar.vue';
import Header from '../components/header.vue';
import Footer from '../components/footer.vue';

export default {
    name: "Dashboard",
    components: {Footer, Header, Sidebar},
    mounted: function () {
        this.add_more_one();
        this.add_more_two();
    },
    data() {
        return {
            name: '',
            description: '',
            img: '',
            strSuccess: '',
            strError: '',
            imgPreview: null,
            form: {
                lineOnes: [],
                lineTwos: [],
                color: '',
                size: '',
                type: '',
                qty: '',
                submitted_to: '',
                pcs: '',
            },
        }
    },
    created() {
        if (window.Laravel.user) {
            this.name = window.Laravel.user.name
        }
    },
    methods: {
        add_more_one: function () {
            this.form.lineOnes.push({
                color: '',
                size: '',
                type: '',
                qty: ''
            })
        },
        add_more_two: function () {
            this.form.lineTwos.push({
                submitted_to: '',
                pcs: '',
            })
        },
        removeLineOne: function (index) {
            this.form.lineOnes.splice(index, 1);
        },
        removeLineTwo: function (index) {
            this.form.lineTwos.splice(index, 1);
        },
        formSubmit: function (e) {
            e.preventDefault();
            let currentObj = this;

            const formData = new FormData();
            formData.append('name', this.name);
            formData.append('description', this.description);

            axios.post('/api/sample/requisition_store', {data: this.form})
            this.$swal({
                title: "DONE!!!",
                text: "SAMPLE REQUISITION INSERT SUCCESSFULLY!",
                icon: "success",
                showCancelButton: false,
                showConfirmButton: true,
                timer: 4000
            }).then(response => {
                $(location).attr('href', '/dashboard')
            })
                .catch(function (error) {
                    alert('Error');
                });
        },
        logout(e) {
            e.preventDefault()
            this.$axios.get('/sanctum/csrf-cookie').then(response => {
                this.$axios.post('/api/logout')
                    .then(response => {
                        if (response.data.success) {
                            window.location.href = "/"
                        } else {
                            console.log(response);
                        }
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            })
        }
    },
    beforeRouteEnter(to, from, next) {
        if (!window.Laravel.isLoggedin) {
            window.location.href = "/";
        }
        next();
    }
}
</script>
